// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
    This file handle common CSS property for custom interface list view template
*/
.container-list-component {
  padding-right: 0;
}

.list-col-text {
  padding-left: 0;
}

.list-col-value {
  text-align: right;
  padding-right: 0;
}

.center-vertically-horizzontally {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/theme/supervision-list-common.scss","webpack://./src/components/template%20component/one-command-template/one-command-template.component.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,gBAAA;ACAJ;;ADGA;EACI,eAAA;ACAJ;;ADGA;EACI,iBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,kBAAA;ACAJ","sourcesContent":["/**\n    This file handle common CSS property for custom interface list view template\n*/\n\n.container-list-component {\n    padding-right: 0;\n}\n\n.list-col-text{\n    padding-left: 0;\n}\n\n.list-col-value{\n    text-align: right; \n    padding-right: 0;\n} \n\n.center-vertically-horizzontally{\n    text-align: center;\n}","/**\n    This file handle common CSS property for custom interface list view template\n*/\n.container-list-component {\n  padding-right: 0;\n}\n\n.list-col-text {\n  padding-left: 0;\n}\n\n.list-col-value {\n  text-align: right;\n  padding-right: 0;\n}\n\n.center-vertically-horizzontally {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
